export default __webpack_public_path__ + "static/media/thumb-GNSS-Antenna-3.9290bcef.png";